<aside id="toolbox">
	<div><ng-container *layoutAttach="toolbox$ | async"></ng-container></div>
</aside>
<main class="d-flex flex-column">
	<header>
		<ng-container *layoutAttach="header$ | async"></ng-container>
		<aside id="floatingSidebar"
			   [class.show-floating-sidebar]="floatingSidebarToggled$ | async"
			   [class.patient-card-visible]="patientCardVisible$ | async">
			<div class="floating-sidebar-wrapper"
				 libClickOutside
				 [toggled]="floatingSidebarToggled$ | async"
				 [elementName]="layoutElements.floatingSidebar"
				 (clickOutside)="clickOutsideEvent($event)">
				<ng-container *layoutAttach="floatingSidebar$ | async"></ng-container>
			</div>
		</aside>
	</header>
	<section class="flex-grow-1"
			 [@routeAnimations]="getRouteAnimationData()">
		<router-outlet></router-outlet>
	</section>
	<aside id="bottomBar"
		   [class.show-bar]="(bottomBarToggled$ | async)">
		<div class="bottom-bar-wrapper"
			 libClickOutside
			 [toggled]="bottomBarToggled$ | async"
			 [elementName]="layoutElements.bottomBar"
			 (clickOutside)="clickOutsideEvent($event)">
			<ng-container *layoutAttach="bottomBar$ | async"></ng-container>
		</div>
	</aside>
	<layout-footer></layout-footer>
</main>
